const rankingItems = [
  { rank: 1, title: '狂飙', type: '电视剧', heat: '9.8', tag: '热播中', tagColor: 'bg-primary-100 text-primary-700' },
  { rank: 2, title: '流浪地球3', type: '电影', heat: '9.7', tag: '新上线', tagColor: 'bg-accent-100 text-accent-700' },
  { rank: 3, title: '庆余年第二季', type: '电视剧', heat: '9.6', tag: '热播中', tagColor: 'bg-primary-100 text-primary-700' },
  { rank: 4, title: '唐朝诡事录之西行', type: '电视剧', heat: '9.5', tag: '更新中', tagColor: 'bg-secondary-100 text-secondary-700' },
  { rank: 5, title: '孤注一掷', type: '电影', heat: '9.4', tag: '高分推荐', tagColor: 'bg-accent-100 text-accent-700' },
  { rank: 6, title: '玫瑰的故事', type: '电视剧', heat: '9.3', tag: '热播中', tagColor: 'bg-primary-100 text-primary-700' },
  { rank: 7, title: '飞驰人生3', type: '电影', heat: '9.2', tag: '新上线', tagColor: 'bg-accent-100 text-accent-700' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              热度榜单
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              实时更新的影视热度排名，看看大家都在看什么
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 px-5 py-3.5 border-b border-background-100 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer"
              >
                <div className="w-8 flex-shrink-0 text-center">
                  {item.rank <= 3 ? (
                    <span className={`inline-flex items-center justify-center w-7 h-7 rounded-lg text-xs font-bold ${
                      item.rank === 1 ? 'bg-primary-500 text-background-50' :
                      item.rank === 2 ? 'bg-accent-500 text-background-50' :
                      'bg-secondary-500 text-background-50'
                    }`}>
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-sm font-semibold text-foreground-400">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-heading font-semibold text-foreground-950 text-sm truncate">
                      {item.title}
                    </span>
                    <span className={`px-1.5 py-0.5 rounded text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.type}</span>
                </div>

                <div className="flex-shrink-0 flex items-center gap-1">
                  <i className="ri-fire-line text-primary-500 text-sm"></i>
                  <span className="text-sm font-bold text-primary-500">{item.heat}</span>
                </div>

                <div className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-play-line text-sm"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}